module.exports = __webpack_public_path__ + "1be8547afda49ed3f833d69d811836d1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/avatar3.png
 ** module id = 300
 ** module chunks = 0
 **/